<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goOrder"
              >keyboard_arrow_left</i
            >
            <span class="title-text" @click="goOrder">{{
              $t("message.yourOrder")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-padding" />
    <div class="container-fluid cart-items-holder">
      <template v-for="(item, index) in giftCartItems">
        <cart-item :cart-item="item" :key="index" />
      </template>
    </div>
    <footer class="cart-footer">
      <div class="container-fluid">
        <div
          class="row mcart-totals"
          v-show="giftCartItems.length > 0 && giftCartValue > 0"
        >
          <CouponComponent
            ref="couponComponent"
            :qrcode="qrcode"
            :ForMobile="true"
            :className="'mcart-totals'"
          ></CouponComponent>
        </div>
        <div class="row mcart-totals">
          <div class="col-6">{{ $t("message.discount") }}</div>
          <div class="col-6 mtotal-price">{{ giftDiscount | formatMoney }}</div>
        </div>
        <div class="row mcart-totals">
          <div class="col-6">{{ $t("message.subtotal") }}</div>
          <div class="col-6 mtotal-price">
            {{ giftCartValue | formatMoney }}
          </div>
        </div>
        <div class="row mcart-total">
          <div class="col-6">{{ $t("message.total") }}</div>
          <div class="col-6 mtotal-price">
            {{ giftTotalPrice | formatMoney }}
          </div>
        </div>
        <div v-if="!exceedMinPurchase" class="p-2 text-danger text-center">
          {{ $t("message.minimumPurchaseIs") }} {{ minPurchase | formatMoney }}
        </div>
      </div>
      <div class="extras-footer">
        <router-link
          :to="{
            name: 'giftstore',
            params: {
              storeid: $route.params.storeid,
              storename: $route.params.storename
            }
          }"
          class="btn btn-cancel"
          >{{ $t("message.cancel") }}</router-link
        >
        <router-link
          :to="{
            name: 'giftcardCheckout',
            params: {
              storeid: $route.params.storeid,
              storename: $route.params.storename
            }
          }"
          :class="{ disabled: orderDisbaled ? 'disabled' : '' }"
          class="btn btn-primary"
          >{{ "Continue" }}</router-link
        >
      </div>
    </footer>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapGetters, mapMutations, mapActions } from "vuex";
import CartItem from "./GiftCartItem";
import { getStore } from "../../../api/services/storeService.js";
import CouponComponent from "../../shop/shopping-cart/CouponComponent";

export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    CouponComponent
  },
  props: {
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: 3
    },
    qrcode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      store: {},

      timerId: null,
      deliveryFee: 0,
      minPurchase: 0
    };
  },
  computed: {
    ...mapGetters([
      "giftCartValue",
      "giftCartItems",
      "giftTotalPrice",
      "giftDiscount"
    ]),
    cartLength() {
      let sum = 0;
      this.giftCartItems.forEach(element => {
        sum += parseInt(element.quantity);
      });
      return sum;
    },
    exceedMinPurchase() {
      return this.giftTotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local()
        .set({ hour: 10 })
        .toUTC();
    },
    now() {
      return DateTime.toUTC();
    },
    orderDisbaled() {
      return (
        !this.exceedMinPurchase ||
        this.proccessing ||
        this.giftCartItems.length === 0
      );
    }
  },
  watch: {
    store() {
      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    giftTotalPrice() {
      this.computeRules(this.orderMode);
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...mapMutations(["REMOVE_GIFTCART_ITEM", "setDeliveryFee"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    continueOrder() {
      this.$router.push({
        name: "giftstore",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime)) {
        this.giftCartItems.forEach(element => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_GIFTCART_ITEM({ item: element });
          }
        });
      }
    },
    computeRules() {
      //delivery fee
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            this.giftTotalPrice > rule.PriceRangeMinimum &&
            this.giftTotalPrice < rule.PriceRangeMaximum
          ) {
            this.deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }
      //this.setDeliveryFee(this.deliveryFee);
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },
    goOrder() {
      this.$router.push({
        name: "giftstore",
        params: { storeid: this.store.ID, storename: this.store.Name }
      });
    }
  }
};
</script>
